const incomeCategories = [
  { label: 'Product category', value: '' },
  { label: 'Salary', value: 'salary' },
  { label: 'Add. income', value: 'add.income' },
];

export default incomeCategories;
